import { ReactNode } from 'react'

export function FormItem({ children }: { children: ReactNode }) {
  return (
    <div className="flex w-full items-center space-x-2 px-3 py-5 text-left md:space-x-4 md:px-5 md:py-4">
      <div className="flex-1">{children}</div>
    </div>
  )
}
